/* FLGNTLT Herbst-Aktion — Popup-Steuerung + Warenkorb-Fortschritt
   ---------------------------------------------------------------------------
   Öffnen: nach Verzögerung oder Exit-Intent (Desktop). Schließen: X, „Später
   vielleicht", Veil, Esc. Frequency-Cap über localStorage je Kampagnen-ID.

   Bewusst ohne Framework und ohne Abhängigkeit vom Theme-JS: Das Popup soll auch
   dann funktionieren, wenn eine Fremd-App das Theme-JS blockiert.
*/
(function () {
  'use strict';

  // Schutz gegen doppelte Ausfuehrung: Popup-Section UND Warenkorb-Snippet laden dieselbe Datei.
  // Ohne diesen Riegel liefen auf der Warenkorbseite zwei Instanzen mit doppelten Timern.
  if (window.__fhPopupInit) return;
  window.__fhPopupInit = true;

  var root = document.querySelector('[data-fh-popup]');
  if (!root) return;

  var tab = document.querySelector('[data-fh-tab]');
  var campaign = root.getAttribute('data-campaign') || 'herbst';
  var key = 'flgntlt_' + campaign + '_dismissed';
  var delayRoh = parseInt(root.getAttribute('data-delay'), 10);
  // `|| 3000` machte aus der Einstellung 0 (= sofort) stillschweigend 3 Sekunden.
  var delay = isNaN(delayRoh) ? 3000 : delayRoh;
  var capDays = parseInt(root.getAttribute('data-days'), 10) || 7;
  var letzterFokus = null;
  var offen = false;
  var overflowVorher = '';
  var geladen = Date.now();   // Bezugspunkt fuer die Verzoegerung — auch nach der Cookie-Zustimmung

  function unterdrueckt() {
    try {
      var v = window.localStorage.getItem(key);
      if (!v) return false;
      // Marker "cta" = dauerhaft bis Kampagnenende (Handoff: nach Klick nicht erneut zeigen)
      if (v === 'cta') return true;
      var alter = Date.now() - parseInt(v, 10);
      return alter < capDays * 86400000;
    } catch (e) {
      return false; // kein localStorage (Privatmodus) => lieber zeigen als crashen
    }
  }

  function merken(wert) {
    try { window.localStorage.setItem(key, wert); } catch (e) { /* egal */ }
  }

  function fokussierbare() {
    // `a[href]` holte auch die Kacheln der zweiten Marquee-Gruppe, die `tabindex="-1"` tragen -
    // damit war das "letzte" Element gar nicht tabbar und die Vorwaertsumlenkung feuerte nie.
    var alle = root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]');
    return Array.prototype.filter.call(alle, function (el) {
      return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null;
    });
  }

  function reiter(sichtbar) {
    if (tab) tab.hidden = !sichtbar;
  }

  // Fremd-Widgets, die ueber dem offenen Dialog liegen (Chat-Blase `n8n-chat` mit z-index 9999,
  // 20.09. auf dem iPhone gemessen: sie deckte die Produktleiste und die Fusszeile ab). Ein modaler
  // Dialog, ueber dem noch etwas klickbar liegt, ist keiner. Deshalb werden feste Elemente, die den
  // Dialog schneiden und mindestens seinen z-index haben, fuer die Dauer des Popups unsichtbar
  // gemacht und beim Schliessen exakt zurueckgesetzt. Der Cookie-Banner bleibt unberuehrt — auf den
  // wird vor dem Oeffnen gewartet, und er darf nie unsichtbar werden.
  var versteckteFremde = [];
  function fremdeVerstecken() {
    if (!offen) return;
    var dlg = root.querySelector('.fh-dialog');
    if (!dlg) return;
    var d = dlg.getBoundingClientRect();
    var zRoot = parseInt(window.getComputedStyle(root).zIndex, 10) || 0;
    var alle = document.body.querySelectorAll('div, section, aside, iframe, button');
    Array.prototype.forEach.call(alle, function (el) {
      if (root.contains(el) || (tab && tab.contains(el))) return;
      if (el.id && (el.id.indexOf('shopify-pc__') === 0 || el.id.indexOf('PBar') === 0)) return;
      if (versteckteFremde.some(function (v) { return v.el === el || v.el.contains(el); })) return;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      if ((parseInt(cs.zIndex, 10) || 0) < zRoot) return;
      var b = el.getBoundingClientRect();
      if (b.width < 8 || b.height < 8) return;
      if (b.right < d.left || b.left > d.right || b.bottom < d.top || b.top > d.bottom) return;
      versteckteFremde.push({ el: el, vorher: el.style.visibility });
      el.style.visibility = 'hidden';
    });
  }
  function fremdeZeigen() {
    versteckteFremde.forEach(function (v) { v.el.style.visibility = v.vorher; });
    versteckteFremde = [];
  }

  // erzwingen = Klick auf den Reiter. Der Besucher will es sehen, also gilt die Frequenz-Sperre nicht.
  function oeffnen(erzwingen) {
    if (offen) return;
    if (!erzwingen && unterdrueckt()) return;
    offen = true;
    // Schon beim OEFFNEN als gesehen merken, nicht erst beim Schliessen (CEO 20.09.: „nach 5 sec
    // EINMAL aufgehen"). Wer eine Kachel antippt oder zurueckspringt, verlaesst die Seite ohne
    // Schliessen — vorher ging das Popup auf der naechsten Seite erneut auf. Der Reiter holt es zurueck.
    merken(String(Date.now()));
    letzterFokus = document.activeElement;
    root.hidden = false;
    reiter(false);
    // Vorherigen Wert merken: War der Theme-Drawer offen, hatte ER die Sperre gesetzt - unser
    // Schliessen darf sie ihm nicht wegnehmen.
    overflowVorher = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var schliessen = root.querySelector('.fh-close');
    if (schliessen) schliessen.focus();
    document.addEventListener('keydown', aufTaste);
    // Sofort und noch einmal spaeter: Chat-Widgets haengen sich erst Sekunden nach dem Laden ein.
    fremdeVerstecken();
    window.setTimeout(fremdeVerstecken, 1500);
    window.setTimeout(fremdeVerstecken, 4000);
  }

  function zu(grund) {
    if (!offen) return;
    offen = false;
    root.hidden = true;
    fremdeZeigen();
    document.body.style.overflow = overflowVorher;
    document.removeEventListener('keydown', aufTaste);
    merken(grund === 'cta' ? 'cta' : String(Date.now()));
    reiter(true);
    if (letzterFokus && letzterFokus.focus) letzterFokus.focus();
  }

  function aufTaste(e) {
    if (e.key === 'Escape') { zu('esc'); return; }
    if (e.key !== 'Tab') return;
    var f = fokussierbare();
    if (!f.length) return;
    var erst = f[0], letzt = f[f.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-fh-close]')) { e.preventDefault(); zu('close'); }
    else if (e.target.closest('[data-fh-cta]')) { merken('cta'); }
  });

  if (tab) {
    tab.addEventListener('click', function () { oeffnen(true); });
  }

  // Der Cookie-Banner sitzt unten und verdeckt bei Erstbesuchern genau den Knopf (19.09. im
  // LIVE-Screenshot gesehen). Deshalb wird gewartet, bis er weg ist. Bleibt er stehen, oeffnet das
  // Popup gar nicht - stattdessen erscheint der Reiter, ueber den es jederzeit erreichbar ist.
  // 🔴 ALLE Kandidaten pruefen, nicht nur den ersten — und Nicht-Sichtbares ueberspringen.
  // Shopify legt VOR dem Banner ein `<style id="shopify-pc__banner__styles">` ins DOM. Das passt auf
  // `[id^="shopify-pc__banner"]`, und `querySelector` liefert das ERSTE Element in Dokumentreihenfolge:
  // also das Stylesheet mit Hoehe 0. Ergebnis: „kein Banner", obwohl der Banner unten steht (20.09.
  // gemessen). Genau dieser tote Check war der Grund, warum spaeter die Privacy-API als Ersatz einsprang
  // — die meldet in diesem Shop aber DAUERHAFT „Banner faellig" und sperrte dann das Popup fuer alle
  // wiederkehrenden Besucher aus. Ein Selektor, der knapp danebengreift, erzeugt zwei Fehler auf einmal.
  function bannerImDom() {
    var kandidaten = document.querySelectorAll('#shopify-pc__banner, [id^="shopify-pc__banner"], .shopify-pc__banner');
    for (var i = 0; i < kandidaten.length; i++) {
      var b = kandidaten[i];
      var tag = b.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK' || tag === 'TEMPLATE') continue;
      var cs = window.getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) continue;
      if (b.getBoundingClientRect().height > 0) return true;
    }
    return false;
  }

  // 🔴 NUR das DOM entscheidet, ob ein Banner im Weg ist — NICHT `shouldShowBanner()`.
  // Gemessen am 20.09. live: die Privacy-API meldet in diesem Shop DAUERHAFT `true`, auch nachdem der
  // Kunde zugestimmt hat und der Banner verschwunden ist. Wer die API als Sperre benutzt, laesst das
  // Popup fuer jeden WIEDERKEHRENDEN Besucher nie aufgehen: Der sieht keinen Banner mehr, also feuert
  // auch kein `visitorConsentCollected`, und die Warteschleife wartet auf ein Signal, das nie kommt.
  // Genau das war der Fall („der Banner wird bei mir auf dem iPhone nicht gezeigt"). Ein sichtbares
  // Element im DOM ist die einzige Aussage, die mit dem uebereinstimmt, was der Kunde sieht.
  function bannerImWeg() {
    return bannerImDom();
  }

  // 🔴 Der Reiter ist SOFORT da und bleibt es — er verschwindet nur, solange der Dialog offen steht
  // (CEO 20.09.: „die Sticky Bar sollte immer zu sehen sein"). Vorher erschien er erst beim Schliessen
  // des Popups, bei gesetzter Frequenz-Sperre oder nach 45 s vergeblichen Wartens auf den Cookie-Banner:
  // Wer den Banner stehen liess oder wessen Popup gerade nicht aufging, sah gar keinen Hinweis auf die Aktion.
  reiter(true);

  if (unterdrueckt()) {
    // Schon gesehen oder weggeklickt: kein Popup, nur der Reiter (steht oben schon).
  } else {
    var warteZyklen = 0;
    var freiSeit = 0;
    var versuchen = function () {
      if (bannerImWeg()) {
        freiSeit = 0;
        warteZyklen += 1;
        if (warteZyklen > 60) { reiter(true); return; }   // ~45 s vergeblich gewartet
        window.setTimeout(versuchen, 700);
        return;
      }
      // Entprellung: einmal "kein Banner im DOM" kann auch heissen "noch nicht gerendert" (er kommt
      // verzoegert). Erst wenn ZWEI Pruefungen im Abstand von 600 ms frei sind, wird geoeffnet — das
      // kostet gut eine halbe Sekunde und verhindert, dass das Popup unter dem Banner landet.
      freiSeit += 1;
      if (freiSeit < 2) { window.setTimeout(versuchen, 600); return; }
      oeffnen(false);
    };
    // setTimeout uebergibt sonst nichts, aber explizit ist sicherer als implizit.
    window.setTimeout(versuchen, delay);
    // Wer zustimmt oder ablehnt, soll die Aktion sofort sehen statt bis zum naechsten Zyklus zu warten.
    // Aber nur, wenn der Banner dann wirklich aus dem Bild ist: Das Ereignis feuert auch bei einer
    // Zustimmung ueber die API, waehrend der Banner stehen bleibt — dann lag das Popup UNTER dem Banner
    // (20.09. auf /pl/ gemessen). Geprueft wird hier NUR das DOM, nicht die Privacy-API: nach dem Klick
    // meldete `shouldShowBanner()` in der Messung weiter „faellig", waehrend der Banner laengst weg war —
    // mit der API als Guard kam das Popup nach der Zustimmung gar nicht mehr (Cookie-Test 20.09. rot).
    // Die Verzoegerung gilt ab Seitenaufruf, auch wenn die Zustimmung frueher kommt: Wer nach zwei
    // Sekunden zustimmt, sieht das Popup trotzdem erst nach fuenf (Rest der Verzoegerung, mindestens 500 ms).
    document.addEventListener('visitorConsentCollected', function () {
      var rest = Math.max(500, delay - (Date.now() - geladen));
      window.setTimeout(function () { if (!unterdrueckt() && !bannerImDom()) oeffnen(false); }, rest);
    });
    // Exit-Intent nur auf Zeigergeräten - auf Touch gibt es kein "Maus verlässt oben".
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) oeffnen(false);
      });
    }
  }

})();

/* ---------- Warenkorb-Fortschritt ---------------------------------------
   Zweistufig: erst zum zweiten Teil (Rabatt), dann zur Versandschwelle.
   Die 150-EUR-Stufe ist kein Deko-Element: Die Abbruchquote faellt an genau
   dieser Grenze von 16,8 % auf 12,2 % (gemessen 18.09.2026 ueber 90 Tage).

   Eigene IIFE, nicht im Popup-Block: Auf /cart rendert das Popup bewusst nicht
   (wer dort steht, will zur Kasse). Stand bisher beides in einer Funktion, beendete
   der fehlende Popup-Knoten sie sofort — der Hinweis waere auf der Warenkorbseite
   nie erschienen. Gefunden 19.09.2026 beim Einbau des Reiters.
-------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.__fhCartInit) return;
  window.__fhCartInit = true;

  // KEIN Zwischenspeichern der Knoten und KEIN frueher Ausstieg, wenn gerade keiner da ist:
  // Shopify rendert beim Hinzufuegen den kompletten `.js-contents`-Block neu. Wer sich die Knoten
  // beim Seitenaufbau merkt, beschriftet danach Elemente, die nicht mehr im Dokument haengen - und
  // wessen Warenkorb beim Laden leer war, fuer den gab es ueberhaupt keinen Knoten.
  // Genau das war der Fehler: „lege ich normal ein Teil rein, zeigt der Ausklapp nichts" (CEO 19.09.).
  var laeuft = null;

  var laeuftAbfrage = false;
  var letzterKorb = null;
  var letzteAbfrage = 0;

  function aktualisieren() {
    // Ohne Hinweis-Knoten (Korb ohne Aktionsteile) nur abfragen, wenn der Korb gerade SICHTBAR ist:
    // Die Messung (unten) braucht auch die Vergleichsgruppe „ohne Aktionsteil", aber nicht auf jeder
    // Seite einen /cart.js-Abruf — nur im offenen Ausklapp und auf /cart.
    if (!document.querySelector('[data-fh-cart]') && !korbSichtbar()) return;
    // Ohne Bremse fragten Klick, Theme-Event und DOM-Austausch die Warenkorb-Daten 7 bis 12 Mal je
    // Seitenaufruf ab (19.09. gemessen). Der Beobachter darf deshalb den letzten Stand weiter-
    // verwenden; wer wirklich etwas getan hat (Klick, cart:updated), holt frische Daten - sonst
    // haenge der Hinweis dem Warenkorb hinterher.
    // KEIN Zwischenspeicher mit Mindestabstand mehr. Ein solcher Cache war am 19.09. kurz drin -
    // gegen eine vermeintliche Abfrage-Flut. Die Messung zeigte dann: von 7 Abrufen je Seitenaufruf
    // stammt genau EINER von uns, die anderen sechs von Theme und Apps. Der Cache loeste also kein
    // Problem, verzoegerte aber die Anzeige nach dem Hinzufuegen um bis zu vier Sekunden.
    // Geblieben ist nur der In-Flight-Riegel: zwei gleichzeitige Abfragen bringen nichts.
    // Laeuft schon eine Abfrage, NICHT einfach aussteigen: Genau waehrend sie laeuft, tauscht
    // Shopify beim Hinzufuegen den Warenkorb aus. Der Anstoss des neuen Knotens ginge sonst
    // verloren und der frische Hinweis bliebe fuer immer leer (19.09. im Ausklapp beobachtet).
    if (laeuftAbfrage) {
      window.clearTimeout(laeuft);
      laeuft = window.setTimeout(aktualisieren, 300);
      return;
    }
    laeuftAbfrage = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        laeuftAbfrage = false;
        if (!cart) return;
        letzterKorb = cart;
        letzteAbfrage = Date.now();
        zeichnen(cart);
        melden('state', cart);
        ergSichtMelden(cart);
      })
      .catch(function (e) {
        laeuftAbfrage = false;
        // Nie still verschlucken (CLAUDE.md): der Hinweis bleibt dann einfach stehen, wie er ist.
        if (window.console && console.error) console.error('[flgntlt-herbst] Warenkorb nicht lesbar:', e);
      });
  }

  function zeichnen(cart) {
    // Knoten ERST JETZT holen, nicht vor dem Abruf: dazwischen kann der Warenkorb neu gerendert
    // worden sein, und die alten Knoten haengen dann nicht mehr im Dokument.
    var hinweise = document.querySelectorAll('[data-fh-cart]');
    Array.prototype.forEach.call(hinweise, function (el) {
          var handles = (el.getAttribute('data-fh-handles') || '').split(',').filter(Boolean);
          var qualifiziert = 0;
          cart.items.forEach(function (i) {
            if (handles.indexOf(i.handle) !== -1) qualifiziert += i.quantity;
          });
            var txt = el.querySelector('[data-fh-cart-text]');
          var fill = el.querySelector('[data-fh-cart-fill]');
          if (!txt || !fill) return;

          if (qualifiziert === 0) {
            el.hidden = true;
            return;
          }
          el.hidden = false;
          // Ersparnis aus dem Warenkorb lesen, NICHT als feste Zahl: "60 € gespart" stimmt nur fuer
          // zwei 90-EUR-Teile. Bei zwei 79ern sind es 38 €, bei zwei Jacken 120 € (19.09. korrigiert).
          var gespart = Math.max(0, (cart.total_discount || 0) / 100);
          var gespartTxt = gespart.toLocaleString('de-DE', { minimumFractionDigits: gespart % 1 ? 2 : 0, maximumFractionDigits: 2 });
          // Die Texte kommen aus dem Snippet (data-Attribute), damit sie uebersetzbar sind - hier
          // wird nur die Stufe gewaehlt und der Betrag eingesetzt. „beide" kommt bewusst nirgends
          // mehr vor: bei Hoodie + T-Shirt las es sich, als zaehle das T-Shirt mit (CEO 19.09.).
          var text = function (name, standard) {
            var v = el.getAttribute('data-t-' + name);
            return v && v.length ? v : standard;
          };
          var betrag = gespartTxt + ' €';
          var ungerade = qualifiziert % 2 === 1;
          if (qualifiziert === 1) {
            el.classList.remove('fh-cart--done');
            txt.innerHTML = text('eins', 'Noch <strong>ein Teil aus der Aktion</strong>, dann kosten zwei zusammen 120 €');
            fill.style.width = '50%';
          } else if (ungerade) {
            // Drei, fuenf, sieben Teile: ein Paar ist voll, eines fehlt zur naechsten Ersparnis.
            // Derselbe Null-Guard wie im geraden Zweig - ohne ihn stuende hier „0 € gespart",
            // falls der Warenkorb den Rabatt einmal nicht ausweist.
            // Balken bleibt VOLL: ein Paar ist erreicht. Auf 50 % zurueckzuspringen sah aus, als
            // haette der Kunde etwas verloren.
            el.classList.add('fh-cart--done');
            txt.innerHTML = gespart > 0
              ? text('ungerade', '<strong>{betrag} gespart</strong> · noch ein Teil aus der Aktion für das nächste Paar').replace('{betrag}', betrag)
              : text('ohne', 'Zwei Teile aus der Aktion kosten zusammen 120 €');
            fill.style.width = '100%';
          } else {
            // Bewusst OHNE Versandhinweis: Das Theme zeigt direkt darueber schon „Geben Sie X mehr
            // aus und erhalten Sie kostenlosen Versand" - zweimal dieselbe Aussage im selben
            // Ausklapp liest sich wie ein Fehler (19.09. im Screenshot gesehen). Hier steht nur,
            // was sonst niemand sagt: was die Aktion gerade spart.
            el.classList.add('fh-cart--done');
            txt.innerHTML = gespart > 0
              ? text('gerade', '<strong>{betrag} gespart</strong> mit der Herbst-Aktion').replace('{betrag}', betrag)
              : text('ohne', 'Zwei Teile aus der Aktion kosten zusammen 120 €');
            fill.style.width = '100%';
          }
    });
  }

  function korbSichtbar() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    var d = document.querySelector('cart-drawer');
    return !!d && d.classList.contains('active');
  }

  /* ---------- Messung: Warenkorb-Zustand an die eigene Erfassung -------------
     Warum: Die Conversion-Analyse vom 24.09.2026 konnte nicht sagen, ob Koerbe mit EINEM
     Aktionsteil haeufiger liegen bleiben als Paare — Shopify kennt den Korbinhalt je Sitzung
     nicht. Deshalb meldet das Theme je Warenkorb (Shopify-Cart-Token, Kern ohne "?key=") den
     Zustand teile/paare/rest und den Klick auf „Zur Kasse" an eine eigene Edge Function
     (flgntlt.sd_cart_events). Die Bestellung wird spaeter ueber REST orders.cart_token angehaengt.
     Regeln:
       - NUR mit Analytics-Einwilligung (Shopify.customerPrivacy.analyticsProcessingAllowed —
         gemessen 30.09.: false vor, true nach der Zustimmung; shouldShowBanner taugt NICHT, K208c).
       - Kein eigener Besucher-Schluessel, keine IP: der Cart-Token ist der einzige Bezeichner.
       - Nur Zustandswechsel (sessionStorage-Schluessel), nur bei sichtbarem Korb (Ausklapp offen
         oder /cart) — sonst zaehlte jeder Seitenaufruf als „Warenkorb angesehen".
       - Pruefstaende setzen localStorage flgntlt_intern=1; die Auswertung filtert darueber (K212).
       - sendBeacon mit text/plain: kein Preflight, ueberlebt den Sprung in den Checkout.
  -------------------------------------------------------------------------- */
  var MESS_URL = 'https://dtevowjxfviqiyjwrpef.supabase.co/functions/v1/cart-events';
  var MESS_SCHLUESSEL = 'fh_mess_zuletzt';

  function analyticsErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
      return cp.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  function intern() {
    try { return window.localStorage.getItem('flgntlt_intern') === '1'; } catch (e) { return false; }
  }
  function seite() {
    if (document.body && document.body.classList.contains('template-cart')) return 'cart';
    var d = document.querySelector('cart-drawer');
    return d && d.classList.contains('active') ? 'drawer' : 'other';
  }
  function teileZaehlen(cart) {
    // Dieselbe Zaehlregel wie in zeichnen(): Handles der Kollektion aus dem Hinweis-Knoten.
    // Ohne Knoten (Liquid rendert bei 0 Teilen nichts, K210) ist die Antwort 0 — korrekt.
    var el = document.querySelector('[data-fh-cart]');
    var handles = el ? (el.getAttribute('data-fh-handles') || '').split(',').filter(Boolean) : [];
    var n = 0;
    (cart.items || []).forEach(function (i) { if (handles.indexOf(i.handle) !== -1) n += i.quantity; });
    return n;
  }
  function senden(daten) {
    var body = JSON.stringify(daten);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(MESS_URL, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) { /* unten der Fallback */ }
    try {
      fetch(MESS_URL, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } })
        .catch(function (e) { if (window.console && console.error) console.error('[flgntlt-herbst] Messung nicht gesendet:', e); });
    } catch (e) { /* kein fetch: dann eben nicht gemessen */ }
  }
  function melden(ereignis, cart, detail) {
    if (!cart || !analyticsErlaubt()) return;
    var token = String(cart.token || '').split('?')[0];
    if (!token) return;
    var ort = seite();
    // Ein Zustand zaehlt nur, wenn der Kunde den Korb SIEHT. Nach dem Hinzufuegen kommt der Abruf
    // oft, bevor der Ausklapp offen ist (ort = other) — der naechste Abruf beim Oeffnen meldet dann.
    if (ereignis === 'state' && ort === 'other') return;
    var teile = teileZaehlen(cart);
    var sh = window.Shopify || {};
    var daten = {
      v: 1,
      event: ereignis,
      cart_token: token,
      teile: teile,
      paare: Math.floor(teile / 2),
      rest: teile % 2,
      item_count: cart.item_count | 0,
      total_cents: cart.total_price | 0,
      discount_cents: cart.total_discount | 0,
      currency: cart.currency || '',
      page: ort,
      viewport_w: window.innerWidth | 0,
      locale: sh.locale || '',
      theme_role: (sh.theme && sh.theme.role) || '',
      theme_id: String((sh.theme && sh.theme.id) || ''),
      intern: intern(),
      ua_short: window.innerWidth < 750 ? 'mobil' : 'desktop'
    };
    if (detail) daten.detail = String(detail).slice(0, 64);
    if (ereignis === 'state') {
      var schluessel = [token, teile, daten.item_count, daten.total_cents, ort].join('|');
      try {
        if (window.sessionStorage.getItem(MESS_SCHLUESSEL) === schluessel) return;
        window.sessionStorage.setItem(MESS_SCHLUESSEL, schluessel);
      } catch (e) { /* ohne Speicher: jeden Zustand senden, die Auswertung dedupliziert */ }
    }
    senden(daten);
  }
  // Fuer weitere Bausteine: Ereignis mit dem zuletzt gelesenen Korb melden.
  window.__fhMelden = function (ereignis, detail) { melden(ereignis, letzterKorb, detail); };

  /* ---------- Ergaenzer-Kacheln (01.10.2026, CEO 30.09.: „ein Tipp legt in den Korb") ----------
     Fehlt genau EIN Teil zum Paar, rendert das Liquid bis zu drei Partnerteile in der Groesse des
     wartenden Teils (snippets/flgntlt-herbst-cart-hinweis.liquid, Pool = Kollektion herbst-duo-ergaenzer).
     Hier nur der Klick: Delegation an document, weil der Ausklapp seine Knoten bei jedem Mengenwechsel
     neu rendert (K201) — gemerkte Kacheln waeren Geister. Ohne JS ist jede Kachel ein Link zur
     Produktseite mit vorgewaehlter Groesse (?variant=), der Weg bleibt also offen.
     Erster Anlauf (20.09.) hatte 12 Kacheln, immer sichtbar, nur als Links — „zu unuebersichtlich". */
  var ergBeschaeftigt = false;
  function ergAbschnitte() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.getSectionsToRender === 'function') {
      try { return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { /* unten der Rueckfall */ }
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  // /cart: Die Sections-API will die SECTION-ID aus dem JSON-Template (z. B. `cart-items`), nicht den
  // Dateinamen `main-cart-items` — Dawn haelt sie in `data-id` am Wrapper und benutzt sie in
  // cart-items.getSectionsToRender(). Mit dem Dateinamen kam der Fuss nicht zurueck (01.10. gemessen:
  // Summe blieb bei 90 €). Rueckfall bleibt der Dateiname.
  function ergCartSections() {
    return ['main-cart-items', 'main-cart-footer'].map(function (id) {
      var el = document.getElementById(id);
      return { id: id, section: (el && el.dataset && el.dataset.id) || id };
    });
  }
  // Beide .js-contents aus der Sections-Antwort einsetzen — dieselben Stellen, die Dawns cart.js beim
  // Mengenwechsel austauscht. Danach greifen MutationObserver (Hinweis, Chips, Betrag, Kasse-Leiste) von selbst.
  function ergSeiteNeu(daten) {
    var ok = false;
    ergCartSections().forEach(function (s) {
      var html = daten && daten.sections && (daten.sections[s.section] || daten.sections[s.id]);
      var ziel = document.getElementById(s.id);
      if (!html || !ziel) return;
      var neu = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
      var alt = ziel.querySelector('.js-contents');
      if (neu && alt) { alt.innerHTML = neu.innerHTML; ok = true; }
    });
    var bubbleHtml = daten && daten.sections && daten.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var quelle = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (quelle) bubble.innerHTML = quelle.innerHTML;
    }
    return ok;
  }
  function ergFehler(k) {
    k.classList.add('fw-erg__kachel--fehler');
    var cta = k.querySelector('.fw-erg__cta');
    if (cta) cta.textContent = k.getAttribute('data-t-fehler') || 'Gerade ausverkauft';
    // Ab jetzt ein normaler Link zur Produktseite — dort gibt es alle Groessen.
    k.removeAttribute('data-fw-add');
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-fw-add]');
    if (!k) return;
    e.preventDefault();
    if (ergBeschaeftigt) return;
    ergBeschaeftigt = true;
    k.setAttribute('aria-busy', 'true');
    var vid = Number(k.getAttribute('data-fw-add'));
    melden('ergaenzer_click', letzterKorb, String(vid));
    var aufCart = document.body.classList.contains('template-cart');
    var sections = aufCart
      ? ergCartSections().map(function (s) { return s.section; }).concat(['cart-icon-bubble'])
      : ergAbschnitte();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, daten: d }; }); })
      .then(function (res) {
        // Zwischenzeitlich ausverkauft: Shopify antwortet 422 mit `status` im Body.
        if (!res.ok || (res.daten && res.daten.status)) {
          if (window.console && console.error) console.error('[flgntlt-herbst] Ergaenzer: Shopify lehnt ab', res.daten && res.daten.description);
          ergFehler(k);
          return;
        }
        var d = document.querySelector('cart-drawer');
        if (aufCart) {
          if (!ergSeiteNeu(res.daten)) window.location.reload();
        } else if (d && typeof d.renderContents === 'function') {
          // Dawn versteckt einen leeren Korb mit `is-empty`; renderContents nimmt die Klasse nicht weg (K215).
          d.classList.remove('is-empty');
          d.renderContents(res.daten);
        } else {
          window.location.href = root + 'cart';
        }
        anstossen(300);
        // Den neuen Zustand melden, sobald /cart.js nachgelesen ist (anstossen + Abruf ~ 0,5 s).
        window.setTimeout(function () { melden('ergaenzer_add', letzterKorb, String(vid)); }, 1200);
      })
      .catch(function (err) {
        if (window.console && console.error) console.error('[flgntlt-herbst] Ergaenzer: Hinzufuegen fehlgeschlagen', err);
        ergFehler(k);
      })
      .then(function () { ergBeschaeftigt = false; k.removeAttribute('aria-busy'); });
  });
  // Sichtkontakt: einmal je Korbzustand, wenn Kacheln im sichtbaren Korb stehen (fuer die Quote
  // view -> click -> add in der Auswertung).
  function ergSichtMelden(cart) {
    if (!cart || !document.querySelector('[data-fw-ergaenzer]') || seite() === 'other') return;
    var token = String(cart.token || '').split('?')[0];
    var schl = 'fh_erg_view|' + token + '|' + teileZaehlen(cart);
    try {
      if (window.sessionStorage.getItem(schl)) return;
      window.sessionStorage.setItem(schl, '1');
    } catch (e) { /* ohne Speicher jedes Mal — die Auswertung dedupliziert je Korb */ }
    melden('ergaenzer_view', cart);
  }

  // Entprellt: Beim Hinzufuegen feuern Klick, Theme-Event und DOM-Austausch kurz hintereinander -
  // ohne Bremse waeren das drei Abfragen von /cart.js fuer ein einziges Teil.
  function anstossen(verzoegerung) {
    window.clearTimeout(laeuft);
    laeuft = window.setTimeout(aktualisieren, typeof verzoegerung === 'number' ? verzoegerung : 250);
  }

  anstossen(0);
  // Theme-Events des Drawers abfangen, ohne sie vorauszusetzen.
  // BEWUSST nicht als „frisch": Das Theme feuert diese Ereignisse im Sekundentakt, auch wenn sich
  // nichts geaendert hat. Sie stossen also nur den Zwischenspeicher an; wirklich neu geholt wird
  // nach einem Klick des Kunden (unten) - und spaetestens nach vier Sekunden ohnehin.
  document.addEventListener('cart:refresh', function () { anstossen(); });
  document.addEventListener('cart:updated', function () { anstossen(); });
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('form[action*="/cart"] button, [name="add"], .cart-remove-button, #cart-icon-bubble, .header__icon--cart')) {
      anstossen(700);
    }
  });

  // Messung: Zustand auch beim OEFFNEN des Ausklapps (Dawn setzt `active` am <cart-drawer>) und nach
  // der Cookie-Zustimmung (vorher durfte nichts gesendet werden). Der Kasse-Klick wird sofort mit dem
  // zuletzt gelesenen Korb gemeldet — sendBeacon ueberlebt den Seitenwechsel in den Checkout.
  var drawerKnoten = document.querySelector('cart-drawer');
  if (drawerKnoten && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawerKnoten.classList.contains('active')) anstossen(150);
    }).observe(drawerKnoten, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('visitorConsentCollected', function () { anstossen(300); });
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('#CartDrawer-Checkout, #checkout, #fw-checkout-mobil, .cart__checkout-button')) {
      melden('checkout_click', letzterKorb);
    }
  });

  // Der verlaessliche Weg: Sobald irgendwo ein Hinweis-Knoten NEU im Dokument auftaucht - also nach
  // jedem Neurendern des Warenkorbs - wird er befuellt. Das deckt auch Wege ab, die kein Event
  // feuern und keinen unserer Selektoren treffen.
  if (window.MutationObserver) {
    var beobachter = new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var hinzu = liste[i].addedNodes;
        for (var j = 0; j < hinzu.length; j++) {
          var n = hinzu[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-fh-cart]')) || (n.querySelector && n.querySelector('[data-fh-cart]'))) {
            anstossen(120);
            return;
          }
        }
      }
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }
})();
